import { api } from "./core";

export type Tip = {
  id: string;
  title: string;
  short_html: string;
  detailed_html: string | null;
  button_label: string | null;
  button_url: string | null;
};

export const tipsApi = {
  tips: () => api<Tip[]>("/tips"),
};
